import { getMobileVoiceModalContent } from './MobileVoiceModalContent.js';
import type { ProductModalContentProps } from '../../ProductOfferingsCardCoCo/ProductOfferingsCardContentCoCo/types.js';

export const getMobileBroadbandModalContent = (props: ProductModalContentProps) => {
  return getMobileVoiceModalContent(props);
};
